if (!customElements.get('push-cart-usps')) {
  customElements.define(
    'push-cart-usps',
    class PushCartUsps extends window.BAO.CustomElement() {
      connectedCallback () {
        super.connectedCallback()
      }

      setupListeners () {
        this.uspItems?.forEach(item => {
          this.handleUspClick = this.handleUspClick.bind(this)

          item.addEventListener('click', this.handleUspClick)
        })
      }

      handleUspClick (e) {
        const target = e.target
        const eventId = target.closest('[data-event-id]')?.dataset.eventId

        if (!eventId) return

        window.dataLayer.push({
          event: 'pushcart_usp_click',
          pushCartUspClick: {
            id: eventId,
          },
        })
      }

      get uspItems () {
        return this.els.item?.elements
      }
    },
  )
}
